export default "__VITE_ASSET__BjUNeZJD__"